import { MOCKS as MOCKS_GET } from './files/GETS';
import { MOCKS as MOCKS_POST } from './files/POSTS';

export const prepareUrl = (url: string) => {
  const path = url.replace(/^(https?:\/\/[^/]+)?(\/.*)?$/i, '$2') || '/';
  const [pathWithoutParams] = path.split('?');
  const [cleanPath] = pathWithoutParams.split('#');
  const uuidRegex = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;
  const numericIdRegex = /\/(\d+)(?=\/|$)/g;

  return cleanPath
    .replace(uuidRegex, '{id}')
    .replace(numericIdRegex, '/{id}$1')
    .replace(/\{id\}\d+/g, '{id}');
};

export const apiMockSwitcher = <T>(url: string, method?: string) => {
  let mockData: unknown;

  const preparedUrl = prepareUrl(url);

  switch (method) {
    case 'GET':
      mockData = MOCKS_GET[preparedUrl] !== undefined ? MOCKS_GET[preparedUrl] : undefined;
      break;
    case 'POST':
      mockData = MOCKS_POST[preparedUrl] !== undefined ? MOCKS_POST[preparedUrl] : undefined;
      break;
    default:
      mockData = undefined;
      break;
  }

  if (process.env.REACT_APP_LOCAL_MODE === '1' && mockData !== undefined) {
    return mockData as T;
  }

  return undefined;
};
